import { primaryNav, type NavLink } from "@/content/nav";

// No Next.js, o menu principal é o array fixo de content/nav.ts. No bundle
// standalone do WordPress, o tema injeta o menu de verdade cadastrado em
// Aparência > Menus (via window.SATLABS_CONFIG.menu) — quando ele existir,
// tem prioridade, então editar o menu no admin do WP muda o site de fato.
export function getPrimaryNav(): NavLink[] {
  if (typeof window !== "undefined" && window.SATLABS_CONFIG?.menu?.length) {
    return window.SATLABS_CONFIG.menu;
  }
  return primaryNav;
}
